import React from "react";
import sparkleWhite from "~/images/sparkle-white.svg";
import Button from "./Button";
const GenerateResults = ({ handleGenerate, loading, text }) => {
  return (
    <div className="w-full flex justify-end">
      <Button onClick={handleGenerate} disabled={loading} className="!bg-[#6248fe] !hover:bg-[#593ff5] px-5 py-3 rounded-xl flex items-center space-x-2 transition-colors">
        <img src={sparkleWhite} />
        <span className="font-medium">{text}</span>
      </Button>
    </div>
  );
};
export default GenerateResults;
